"use client";

import React from "react";
import Link from "next/link";
import Image from "next/image";
import { useParams } from "next/navigation";
import { useLocale } from "use-intl";
import VerifiedIcon from "../assets/illu.png";
import NotValid from "../assets/not-valid.svg";
import { translations } from "@/messages";
import { Countdown } from "./Countdown";
type DocumentVerifierProps = {
  isValid?: boolean;
  hideScan?: boolean;
  onDocumentView?: () => void;
  countdownTo?: Date;
  rightSideContent?: React.ReactNode;
};
function useTypedLocale() {
  const {
    locale
  } = useParams();
  const fallbackLocale = useLocale();
  return (locale ?? fallbackLocale) as keyof typeof translations;
}
const DocumentVerifier: React.FC<DocumentVerifierProps> = ({
  isValid,
  hideScan,
  onDocumentView,
  countdownTo,
  rightSideContent
}) => {
  const typedLocale = useTypedLocale();
  const containerClasses = `flex h-full w-full flex-col justify-center gap-4 p-8 tablet:w-auto ${isValid ? "items-start" : "items-center"}`;
  const renderValidContent = () => <div className="flex h-full w-full flex-col justify-center gap-8" data-sentry-component="renderValidContent" data-sentry-source-file="DocumentVerifier.tsx">
      {rightSideContent}
      <button className="w-full rounded-2xl bg-blue-600 px-8 py-3 text-center font-bold text-white transition duration-300 hover:bg-blue-700" onClick={onDocumentView}>
        {translations[typedLocale]["formView"]["viewDocument"]}
      </button>
    </div>;
  const renderInvalidContent = () => <div className="mb-8 w-full text-center text-xl text-gray-700" data-sentry-component="renderInvalidContent" data-sentry-source-file="DocumentVerifier.tsx">
      {translations[typedLocale]["formView"]["cannotVerifyDocument"]}
    </div>;
  return <div className="relative m-0 flex w-full flex-col justify-between overflow-hidden p-0 tablet:flex-row" data-sentry-component="DocumentVerifier" data-sentry-source-file="DocumentVerifier.tsx">
      {/* Left Section */}
      <div className="w-full">
        <Image src={isValid ? VerifiedIcon : NotValid} alt="Verification Status Icon" className="h-auto max-h-[40rem] w-full max-w-[40rem] rounded-3xl" data-sentry-element="Image" data-sentry-source-file="DocumentVerifier.tsx" />
      </div>

      {/* Right Section */}
      <div className="w-full">
        <div className={containerClasses}>
          {isValid ? renderValidContent() : renderInvalidContent()}

          {!hideScan && <Link href={`/${typedLocale}/scan`} className="w-full rounded-2xl bg-yellow-500 px-8 py-3 text-center font-bold text-white transition duration-300 hover:bg-yellow-600">
              {translations[typedLocale]["formView"]["scanAnother"]}
            </Link>}

          {countdownTo && <Countdown countdownTo={countdownTo} typedLocale={typedLocale} />}
        </div>
      </div>
    </div>;
};
export default DocumentVerifier;